import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProjectCreateComponent } from './project-create/project-create.component';
import { ProjectEditComponent } from './project-edit/project-edit.component';
import { ProjectListComponent } from './project-list/project-list.component';
import { ProjectViewComponent } from './project-view/project-view.component';
import { PermissionGuard } from 'app/shared/auth/auth-guard.service';
import { ProductAuditComponent } from './product-audit/product-audit.component';
import { ContractAuditComponent } from './contract-audit/contract-audit.component';

const routes: Routes = [
  {
    path: '',
    children: [
    {
      path:'project-list' , component:ProjectListComponent,
      data: {
        title: 'project List Page',
        canActivate: [PermissionGuard],
        data: { roles: ['Managment','Engineering','Sales','Teacher','admin'] } 
      }
    },
    {
      path:'product-list' , component:ProductAuditComponent,
      data: {
        title: 'product List Page',
        canActivate: [PermissionGuard],
        data: { roles: ['Managment','Engineering','Sales','Teacher','admin'] } 
      }
    },
    {
      path:'contract-list' , component:ContractAuditComponent,
      data: {
        title: 'contract List Page',
        canActivate: [PermissionGuard],
        data: { roles: ['Managment','Engineering','Sales','Teacher','admin'] } 
      }
    },
    {
      path:'project-create' , component:ProjectCreateComponent,
      data: {
        title: 'project create Page'
      }
    },
    {
      path:'project-edit/:id' , component:ProjectEditComponent,
      data: {
        title: 'project edit Page'
      }
    },
    {
      path:'project-view/:id' , component:ProjectViewComponent,
      data: {
        title: 'project view Page'
      }
    }
  ]
  }








];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectRoutingModule { }
